import React, { useState } from 'react';
import Lottie from 'lottie-react';

import { ReactComponent as FilePDF } from '../../assets/icons/FilePDF.svg';
import { ReactComponent as FileCSV } from '../../assets/icons/FileCSV.svg';
import { ReactComponent as CircleCheckBackgroundBlue } from '../../assets/icons/CircleCheckBackgroundBlue.svg';
import { ReactComponent as TriangleAdmiration } from '../../assets/icons/TriangleAdmiration.svg';
import { ReactComponent as XCircleBackgroundBlue } from '../../assets/icons/XCircleBackgroundBlue.svg';
import ArrowButton from '../Buttons/ArrowButton/ArrowButton';
import LoaderNeutral from '../../assets/animations/LoaderNeutral.json';

import classes from './AsyncLoad.module.scss';

// const state = 'PROCESSING/FINISHED/ERROR';

const iconFormat = {
  csv: <FileCSV />,
  pdf: <FilePDF />,
  xlsx: <FileCSV />
};

const AsyncLoad = ({ steps, currentStep, globalState, errorMessage, files }) => {
  const [isOpen, setOpen] = useState(true);
  const [hoverCancelState, setHoverCancelState] = useState(null);

  const changeOpen = () => {
    setOpen(currentOpen => !currentOpen);
  };

  const onClickLeaveFile = () => {
    setHoverCancelState(null);
  };

  const cancelUploadFile = () => {};

  return (
    <div className={classes.content}>
      <div className={classes.card}>
        <div className={classes.steps}>
          <span className='medium-14'>
            Paso {currentStep + 1} de {steps.length}
          </span>
          <span className='semibold-16'>{steps[currentStep].stepTitle}</span>
        </div>
        <ArrowButton open={isOpen} onClick={changeOpen} className={classes.arrow} />
      </div>

      {isOpen && (
        <div>
          {globalState && (
            <div className={classes.error}>
              <TriangleAdmiration />
              <span>{errorMessage}</span>
            </div>
          )}
          <div className={classes.files}>
            {files.map(({ fileName, state, format }, idx) => (
              <div key={idx} className={classes.file}>
                {iconFormat[format]}
                <span className=' text-ellipsis medium-16' title={fileName}>
                  {fileName}
                </span>
                {state === 'PROCESSING' &&
                  (hoverCancelState !== idx ? (
                    <Lottie
                      //onMouseOver={() => onClickHoverCancelFile(idx)}
                      className={classes.load}
                      animationData={LoaderNeutral}
                      loop={true}
                    />
                  ) : (
                    <XCircleBackgroundBlue onClick={cancelUploadFile} className='pointer' onMouseLeave={onClickLeaveFile} />
                  ))}
                {state === 'FINISHED' && <CircleCheckBackgroundBlue className={classes.check} />}
                {state === 'ERROR' && <TriangleAdmiration className={classes.check} />}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default AsyncLoad;
